import { get, isEmpty } from 'lodash';

const isAiGenerated = (value: unknown) => {
  if (typeof value === 'object' || Array.isArray(value)) {
    return !isEmpty(value);
  }

  return value !== null && value !== undefined;
};

const checkIsAiGeneratedForPath = (
  aiGeneratedValues: unknown,
  aiGeneratedPath?: string,
): boolean => {
  if (!aiGeneratedPath) {
    return isAiGenerated(aiGeneratedValues);
  }

  const extractedValue = get(aiGeneratedValues, aiGeneratedPath);
  return isAiGenerated(extractedValue);
};

export { isAiGenerated, checkIsAiGeneratedForPath };
